import { FontOptionLabel } from '../../CaptionsButtonControl/types.ts';

export const getFontVariantForFontOptionLabel = (fontOptionLabel: FontOptionLabel): string =>
  fontOptionLabel === 'Small caps' ? 'small-caps' : 'normal';
